import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";
import { toast } from "sonner";

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState({ name: "", rating: 5, comment: "", location: "" });
  useEffect(() => { api.get("/reviews").then(r => setReviews(r.data.reviews)); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/reviews", form);
      toast.success("Thank you! Your review is live.");
      const { data } = await api.get("/reviews"); setReviews(data.reviews);
      setForm({ name: "", rating: 5, comment: "", location: "" });
    } catch { toast.error("Please try again."); }
  };
  return (
    <div className="pt-32 pb-24 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] font-semibold">Reviews</div>
          <h1 className="mt-3 text-5xl font-bold text-blue-950 dark:text-white">Stories from our travellers</h1>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map(r => (
            <div key={r.id} className="rounded-3xl p-6 bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-white/10">
              <div className="flex gap-1 mb-3">{[...Array(r.rating)].map((_,i)=><Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]"/>)}</div>
              <p className="italic text-slate-700 dark:text-slate-200">"{r.comment}"</p>
              <div className="mt-4 text-sm font-semibold text-blue-950 dark:text-white">{r.name}</div>
              <div className="text-xs text-slate-500">{r.location} · {r.package_slug}</div>
            </div>
          ))}
        </div>
        <form onSubmit={submit} data-testid="review-form" className="mt-16 rounded-3xl p-8 bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-white/10 space-y-4">
          <h2 className="text-2xl font-bold text-blue-950 dark:text-white">Share your story</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <input required data-testid="review-name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Your name"
              className="rounded-2xl border border-slate-200 dark:border-white/10 bg-transparent px-4 py-3"/>
            <input data-testid="review-location" value={form.location} onChange={e=>setForm({...form,location:e.target.value})} placeholder="Location"
              className="rounded-2xl border border-slate-200 dark:border-white/10 bg-transparent px-4 py-3"/>
            <select data-testid="review-rating" value={form.rating} onChange={e=>setForm({...form,rating:+e.target.value})}
              className="rounded-2xl border border-slate-200 dark:border-white/10 bg-transparent px-4 py-3">
              {[5,4,3,2,1].map(n => <option key={n} value={n}>{n} ★</option>)}
            </select>
          </div>
          <textarea required data-testid="review-comment" value={form.comment} onChange={e=>setForm({...form,comment:e.target.value})} rows={4} placeholder="Tell us about your trip..."
            className="w-full rounded-2xl border border-slate-200 dark:border-white/10 bg-transparent px-4 py-3"/>
          <button data-testid="review-submit" className="px-6 py-3 rounded-full btn-gold text-sm">Submit review</button>
        </form>
      </div>
    </div>
  );
}
